import React from 'react';
import { useTranslation } from 'react-i18next';
import { QCharacterCount, QFormControl, QInput, QStack, QTextarea } from '@qualio/ui-components';
import { Controller, UseFormReturn } from 'react-hook-form';
import { DigitalSignatureV2 } from '../../../types/digitalSignature';

type Props = {
  control: UseFormReturn<DigitalSignatureV2>['control'];
  isCommentRequired: boolean;
  emailPlaceholder?: string;
  passwordPlaceholder?: string;
  commentLabel?: string;
  commentPlaceholder?: string;
};

const DigitalSignatureForm: React.FC<Props> = ({
  control,
  isCommentRequired,
  emailPlaceholder,
  passwordPlaceholder,
  commentLabel,
  commentPlaceholder,
}) => {
  const { t } = useTranslation();
  return (
    <QStack direction="column" spacing={4}>
      <Controller
        control={control}
        name="email"
        render={({ field, fieldState }) => {
          return (
            <QFormControl
              label={t('common.labels.email')}
              error={fieldState.error?.message}
              isInvalid={Boolean(fieldState.error)}
              isRequired
              data-cy="email-input"
            >
              <QInput {...field} autoComplete="username" placeholder={emailPlaceholder ? emailPlaceholder : ''} />
            </QFormControl>
          );
        }}
      />
      <Controller
        control={control}
        name="password"
        render={({ field, fieldState }) => {
          return (
            <QFormControl
              label={t('common.labels.password')}
              error={fieldState.error?.message}
              isInvalid={Boolean(fieldState.error)}
              isRequired
              data-cy="password-input"
            >
              <QInput
                type="password"
                {...field}
                autoComplete="current-password"
                placeholder={passwordPlaceholder ? passwordPlaceholder : ''}
              />
            </QFormControl>
          );
        }}
      />
      <Controller
        control={control}
        name="comment"
        render={({ field, fieldState }) => {
          const { ref: _ref, ...fieldProps } = field;

          return (
            <QFormControl
              label={commentLabel ? commentLabel : t('common.labels.comment')}
              error={fieldState.error?.message}
              isInvalid={Boolean(fieldState.error)}
              isRequired={isCommentRequired}
            >
              <QTextarea
                data-cy="comment-input"
                {...fieldProps}
                placeholder={commentPlaceholder ? commentPlaceholder : ''}
              >
                <QCharacterCount max={1000} />
              </QTextarea>
            </QFormControl>
          );
        }}
      />
    </QStack>
  );
};

export default DigitalSignatureForm;
